const RouteConstant: any = {
  pageLayout: "/",
  userDetails: "/user-details",
  assetDetails: "/asset-details",
  customerDetails: "/customer-details",
};

export default RouteConstant;
